import { FallbackMetadata } from '../types/ContentsInterface';

export const defaultSEOConfig: Record<string, FallbackMetadata> = {
  '/': {
    title: 'The Marketing Content Specialist | gimmefy.ai',
    description: 'Unleash campaign-ready marketing content in minutes with gimmefy—the content specialist powered by smart AI. Start free and create, brand, and launch with ease.',
    keywords: 'AI marketing, content creation, marketing automation, AI tools, digital marketing',
    image: 'hero-image.png'
  },
  '/enterprise': {
    title: 'Enterprise AI Marketing Solutions | gimmefy',
    description: 'Enterprise-grade AI marketing platform for large organizations. Scale your marketing operations with advanced AI capabilities.',
    keywords: 'enterprise AI, marketing automation, B2B marketing, AI platform, enterprise solutions',
    image: 'enterprise-ceo.jpg'
  },
  '/startups': {
    title: 'AI Marketing for Startups | gimmefy',
    description: 'Accelerate your startup growth with AI-powered marketing tools. Create compelling content and reach your audience faster.',
    keywords: 'startup marketing, AI tools, growth marketing, content creation, startup growth',
    image: 'hero-startup-innovation.jpg'
  },
  '/creators-and-influencers': {
    title: 'AI Tools for Creators & Influencers | gimmefy',
    description: 'Supercharge your content creation with AI. Generate engaging posts, videos, and campaigns that resonate with your audience.',
    keywords: 'content creator, influencer marketing, AI content, social media, creator tools',
    image: 'hero-creator-workspace.jpg'
  },
  '/retail': {
    title: 'AI Marketing for Retail | gimmefy',
    description: 'Revolutionize your retail marketing with AI. Create personalized campaigns, optimize conversions, and boost sales.',
    keywords: 'retail marketing, e-commerce, AI retail, digital marketing, conversion optimization',
    image: 'hero-retail-marketing.jpg'
  },
  '/freelancers': {
    title: 'AI Marketing Tools for Freelancers | gimmefy',
    description: 'Boost your freelance business with AI marketing tools. Create professional content and win more clients.',
    keywords: 'freelance marketing, AI tools, content creation, freelance business, digital marketing',
    image: 'hero-ai-marketing.jpg'
  },
  '/studio': {
    title: 'AI Content Studio | gimmefy',
    description: 'Create stunning visual content with AI. Design graphics, videos, and marketing materials in minutes.',
    keywords: 'content studio, AI design, visual content, graphic design, video creation',
    image: 'hero-image.png'
  },
  '/agents': {
    title: 'AI Marketing Agents | gimmefy',
    description: 'Deploy AI agents to automate your marketing tasks. From content creation to campaign management.',
    keywords: 'AI agents, marketing automation, intelligent automation, AI assistants, marketing tasks',
    image: 'hero-image.png'
  },
  '/playbooks': {
    title: 'Marketing Playbooks | gimmefy',
    description: 'Proven marketing strategies and templates. Execute successful campaigns with AI-powered playbooks.',
    keywords: 'marketing playbooks, strategies, templates, campaign execution, marketing automation',
    image: 'hero-image.png'
  },
  '/visual-lab': {
    title: 'AI Visual Lab | gimmefy',
    description: 'Experiment with AI-powered visual content creation. Generate images, videos, and graphics instantly.',
    keywords: 'visual content, AI generation, image creation, video generation, creative tools',
    image: 'hero-image.png'
  },
  '/about': {
    title: 'About gimmefy | AI Marketing Platform',
    description: 'Learn about gimmefy\'s mission to democratize AI marketing. Our story, team, and vision for the future.',
    keywords: 'about gimmefy, company story, AI marketing platform, team, mission',
    image: 'hero-image.png'
  },
  '/contact': {
    title: 'Contact gimmefy | Get in Touch',
    description: 'Get in touch with the gimmefy team. We\'re here to help you transform your marketing with AI.',
    keywords: 'contact gimmefy, support, customer service, AI marketing help, get started',
    image: 'hero-image.png'
  },
  '/terms-of-use': {
    title: 'Terms of Use | gimmefy',
    description: 'Read gimmefy\'s terms of use and service agreement. Understand our policies and your rights.',
    keywords: 'terms of use, service agreement, legal, policies, gimmefy terms',
    image: 'hero-image.png'
  },
  '/privacy-policy': {
    title: 'Privacy Policy | gimmefy',
    description: 'Learn how gimmefy protects your privacy and handles your data. Our commitment to data security.',
    keywords: 'privacy policy, data protection, GDPR, privacy, data security',
    image: 'hero-image.png'
  },
  '/create-social-content-calendars-with-ai': {
    title: 'Create Social Content Calendars with AI | gimmefy.ai',
    description: 'Never run out of content ideas or face empty weeks again. Plan, create, and schedule every post, campaign, and story from one powerful platform.',
    keywords: 'AI content calendar, social media planning, content creation, social media automation, content scheduling, social media marketing',
    image: 'hero-ai-marketing.jpg'
  },
  '/launch-marketing-campaigns-with-ai': {
    title: 'Launch Marketing Campaigns with AI | gimmefy.ai',
    description: 'Never run out of content ideas or face empty weeks again. Plan, create, and schedule every post, campaign, and story from one powerful platform.',
    keywords: 'AI marketing campaigns, campaign creation, marketing automation, AI content, digital marketing, campaign planning',
    image: 'hero-ai-marketing.jpg'
  },
  '/generate-blog-articles-with-ai': {
    title: 'Create Social Content Calendars with AI | gimmefy.ai',
    description: 'Never run out of content ideas or face empty weeks again. Plan, create, and schedule every post, campaign, and story from one powerful platform.',
    keywords: 'AI content calendar, social media planning, content creation, social media automation, content scheduling, social media marketing',
    image: 'hero-ai-marketing.jpg'
  },
  '/getting-started': {
    title: 'Getting Started with gimmefy | Video Tutorials & Guides',
    description: 'Learn how to use gimmefy\'s AI marketing platform with our step-by-step video tutorials. Master Studio, Brand Vault, Agents, and more with guided walkthroughs.',
    keywords: 'gimmefy tutorials, getting started guide, AI marketing tutorial, video walkthrough, how to use gimmefy, marketing automation guide',
    image: 'hero-image.png'
  },
  '/ai-ad-gallery': {
    title: 'AI-Powered Ad Showcase | gimmefy Gallery',
    description: 'Explore our collection of AI-generated advertisements created with gimmefy. See real examples of high-impact ads across social media, display, video, and print formats.',
    keywords: 'AI ads, advertisement gallery, AI-generated marketing, gimmefy examples, marketing showcase, AI advertising, creative examples',
    image: 'hero-image.png'
  },
  '/gimmefy-gallery': {
    title: 'gimmefy Gallery | AI-Powered Ad Showcase',
    description: 'Explore our collection of AI-generated advertisements created with gimmefy. See real examples of high-impact ads across social media, display, video, and print formats.',
    keywords: 'AI ads, advertisement gallery, AI-generated marketing, gimmefy examples, marketing showcase, AI advertising, creative examples',
    image: 'hero-image.png'
  },
  '/daily-circus': {
    title: 'Daily Circus | AI Marketing Comics & Humor | gimmefy',
    description: 'Join the Daily Circus - where AI meets marketing humor! Enjoy weekly comics, marketing insights, and laughs about the wild world of digital marketing.',
    keywords: 'marketing comics, AI humor, marketing jokes, daily circus, marketing entertainment, AI comics, marketing fun',
    image: 'daily-circus-bot.jpg'
  },
  '/360-brand-ai-deep-dive': {
    title: 'Free Brand Analysis & Content Strategy | gimmefy',
    description: 'Get a free, AI-powered brand analysis report covering business profile, tone of voice, audience insights, competitive landscape, and more. Includes 1000 free credits and demo account.',
    keywords: 'free brand analysis, brand analyzer, AI brand report, content strategy, brand audit, competitive analysis, SWOT analysis, brand assessment',
    image: 'hero-ai-marketing.jpg'
  },
  '/get-free-brand-report': {
    title: '360° AI Brand Report - Free Brand Perception Analysis | gimmefy',
    description: 'Get a comprehensive AI-powered analysis of your brand. Discover how the world sees your brand, your positioning, tone of voice, and audience insights - completely free.',
    keywords: 'brand analysis, brand perception, AI brand report, brand positioning, free brand audit, brand analysis tool, marketing insights',
    image: 'brand-report-preview.png'
  },
  '/prompt-and-plate': {
    title: 'Prompt & Plate - AI Lunch for Marketing Leaders | gimmefy',
    description: 'Join senior marketers for a casual Friday lunch discussing AI in marketing. No panels, no pitches - just honest conversation over lunch at Cross Street.',
    keywords: 'AI marketing lunch, marketing networking, senior marketers, AI discussion, marketing leaders, Singapore marketing events',
    image: 'hero-image.png'
  },
  // '/customer-stories': {
  //   title: 'Customer Stories - See How Leading Brands Use gimmefy | gimmefy',
  //   description: 'Discover how Singlife, DBS, Volvo, Unilever, and other leading brands scale content creation, maintain brand consistency, and accelerate campaigns with gimmefy Enterprise.',
  //   keywords: 'gimmefy customer stories, client success stories, enterprise case studies, brand content automation, Singlife gimmefy, DBS marketing automation, Volvo content platform',
  //   image: 'hero-image.png'
  // },
  // '/customer-stories/singlife': {
  //   title: 'Singlife + gimmefy Case Study - Scaling Campaigns Across 100+ SKUs | gimmefy',
  //   description: 'How Singlife scaled creative production across 100+ insurance SKUs with gimmefy Enterprise, achieving 72% faster turnaround and unified brand-safe content creation.',
  //   keywords: 'Singlife case study, insurance marketing automation, SKU scaling, campaign production, gimmefy enterprise, Singapore insurance, digital insurer content',
  //   image: 'hero-image.png'
  // },
  '/roi-calculator': {
    title: 'ROI Calculator - Calculate Your AI Content Savings | gimmefy',
    description: 'Calculate your team\'s potential time and cost savings with AI-powered content creation. See how gimmefy can transform your marketing team\'s efficiency and ROI.',
    keywords: 'ROI calculator, AI content savings, marketing efficiency, content creation ROI, enterprise marketing tools, AI marketing calculator',
    image: 'hero-image.png'
  }
};

export function getFallbackMetadata(pathname: string): FallbackMetadata {
  return defaultSEOConfig[pathname] || {
    title: 'AI For Marketers | gimmefy',
    description: 'Transform your marketing with AI-powered content creation, automation, and analytics.',
    keywords: 'AI marketing, content creation, marketing automation, AI tools',
    image: 'hero-image.png'
  };
}
